import { Injectable } from '@angular/core';
import { OpenApiRemoteMethod, OpenApiRemoteMethodParameter, RxapOpenApiRemoteMethod } from 'eurogard-open-api-remote-method';
import { UserControllerPutRequestWebauthnRegisterPasswordlessParameter } from '../parameters/user-controller-put-request-webauthn-register-passwordless.parameter';
import { UserControllerPutRequestWebauthnRegisterPasswordlessResponse } from '../responses/user-controller-put-request-webauthn-register-passwordless.response';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiRemoteMethod({
    serverId: 'legacy',
    operationId: 'user-controller-putRequestWebauthnRegisterPasswordless',
    operation: '{"operationId":"user-controller-putRequestWebauthnRegisterPasswordless","parameters":[{"name":"userUuid","in":"path","required":true,"schema":{"type":"string","format":"uuid"}}],"responses":{"200":{"content":{"application/json":{"schema":{"type":"object"}}}}},"method":"put","path":"/user-controller/{userUuid}/request-configure-webauthn-register-passwordless"}'
  })
export class UserControllerPutRequestWebauthnRegisterPasswordlessRemoteMethod extends OpenApiRemoteMethod<UserControllerPutRequestWebauthnRegisterPasswordlessResponse, UserControllerPutRequestWebauthnRegisterPasswordlessParameter, void> {
  public override call(parameters: OpenApiRemoteMethodParameter<UserControllerPutRequestWebauthnRegisterPasswordlessParameter, void>): Promise<UserControllerPutRequestWebauthnRegisterPasswordlessResponse> {
    return super.call(parameters);
  }
}
